import React, { useContext } from 'react';
import { Button } from '@progress/kendo-react-buttons';
import * as svg from '@progress/kendo-svg-icons';
import { PinApi } from '../../../../redux/api/PinApi';
import { ITicket, ITicketProps } from '../../../../types/Ticket/ITicket';
import { IPinItem } from '../../../../types/Pin/IPinItem';
import { useGetTenantQuery, useGetUserProfileQuery } from '../../../../redux/api/BaseApi';
import { IUserProfile } from '../../../../types/User/IUserProfile';
import { RevUserContext } from '../../../../context/UserContext';
import { Link } from 'react-router-dom';
import StarApi from '../../../../redux/api/StarApi';
import { Setting } from '../../../../types/Setting/Setting';
import { UserApi } from '../../../../redux/api/UserApi';
import { setFlaggedNotesExpanded, setMenuExpanded } from '../../../../slices/TicketDetailUISlice';
import { useReduxDispatch, useReduxSelector } from '../../../../redux/hooks';
import { isMobile } from 'react-device-detect';
import { useGetHostConfigQuery } from '../../../../redux/api/AccountApi';
import Tools from './Tools/Tools';

const Toolbar: React.FC<ITicketProps> = (ticket) => {
    const dispatch = useReduxDispatch();
    const { menuExpanded, flaggedNotes } = useReduxSelector(state => state.ticketDetailsUI);
    const { data: tenant } = useGetTenantQuery(null);
    const { data: allPins, isFetching } = PinApi.useGetPinsQuery();
    const { data: allStars, isFetching: isFetchingStars } = StarApi.useGetStarsQuery();
    const thisPin = allPins?.find(p => p.Call_Id === ticket.ID);
    const thisStar = allStars?.find(p => p.Call_Id === ticket.ID);
    const profile = useContext<IUserProfile>(RevUserContext)
    const { data: sourceFeature } = UserApi.useGetSettingQuery(Setting.TICKET_SOURCE);
    const { data: userProfile } = useGetUserProfileQuery()
    //Page size is and System setting
    const { data: hostConfig } = useGetHostConfigQuery(userProfile?.Tenant_Uid, { skip: !userProfile?.Tenant_Uid });
    const [pin, { isLoading: savingPin }] = PinApi.useAddPinMutation();
    const [unpin, { isLoading: deletingPin }] = PinApi.useDeletePinMutation();

    const [star, { isLoading: savingStar }] = StarApi.useAddStarMutation();
    const [unstar, { isLoading: deletingStar }] = StarApi.useDeleteStarMutation();

    const pinTicket = () => {
        pin({ Call_Id: ticket.ID } as IPinItem);

    }

    const unpinTicket = () => {
        if (thisPin?.Id)
            unpin(thisPin);
    }

    const starTicket = () => {
        star({ Call_Id: ticket.ID } as IPinItem);
    }

    const unStarTicket = () => {
        if (thisStar?.Id)
            unstar(thisStar);
    }

    const loadingButton = <Button imageUrl='./images/ajax-loader-small.gif'></Button>;
    //Check if this is a staff member or enduser
    var isStaff = profile?.Features?.External_Interface === false;
    var starEnabled = profile?.Features?.Starred_Tickets;
    var sharingEnabled = profile?.Features?.Tagging;
    var printActive = hostConfig?.Print_Layout;

    interface Option {
        text: string;
        value: string;
    };
    const summaryOptions: Option[] = [
        {
            text: 'Description',
            value: 'Description'
        }, {
            text: 'Summary',
            value: 'Summary'
        }]
    const toggleSideBar = () => {
        dispatch(setMenuExpanded(!menuExpanded));

    }

    const tools = Tools(profile);


    return (<>
        <div className='tool-bar d-flex flex-column flex-grow-1'>

            <div className='d-flex flex-row justify-content-between align-items-center'>

                <div className='d-flex align-items-center'>
                    {isMobile && <Button svgIcon={svg.menuIcon} fillMode='flat' color='#fff' onClick={toggleSideBar}></Button>}
                    <div className={(ticket.StateCssClass || 'BlueBG') + ' ticket-number'}>
                        {sourceFeature?.Bool_Value && <div className='source user-select-none'>{ticket.Source_Name || '(unknown)'}</div>}
                        #<span className='user-select-all'>{ticket.ID}</span></div>
                </div>
                <div className="d-flex '">
                    <ul className="m-0">
                        {/* {isStaff && <li className="nav-item ms-2 d-none d-md-inline"> <RelatedButton {...ticket} Is_Loading={false} /> </li>} */}
                        {isStaff && flaggedNotes?.hasNotes && <li className="nav-item ms-2 d-none d-md-inline">
                            <Button title='Flagged notes' size='large' imageUrl='./images/Flag.png' className={flaggedNotes?.expanded ? 'on' : 'off'} onClick={() => dispatch(setFlaggedNotesExpanded(!flaggedNotes?.expanded))} ></Button>
                        </li>}

                        {/* {printActive && isStaff && <li className="nav-item ms-2 d-none d-md-inline">
                            <Link to={`/ticket/${ticket.ID}/print`} title='Print'><Button size='medium' svgIcon={svg.printIcon} className=' off' ></Button></Link>
                        </li>} */}
                        {/* {isStaff && sharingEnabled && <li className="nav-item ms-2 d-none d-md-inline">
                            <Link to={`/ticket/${ticket.ID}/share`} title='Share'><Button size='medium' svgIcon={svg.shareIcon} className='off' ></Button></Link>
                        </li>} */}
                        {profile?.Features?.Pin_Dock &&
                            <li className="nav-item ms-2  d-none d-md-inline">
                                {(savingPin || deletingPin || isFetching) ? loadingButton :
                                    thisPin?.Id ? <Button svgIcon={svg.unpinIcon} title='Un-Pin' onClick={unpinTicket} ></Button> : <Button className='off' svgIcon={svg.pinIcon} title='Pin to dock' onClick={pinTicket} ></Button>
                                }
                            </li>}
                        {isStaff && starEnabled && <li className="nav-item ms-2  d-none d-md-inline">
                            {(savingStar || deletingStar || isFetchingStars) ? loadingButton :
                                thisStar?.Id ? <Button svgIcon={svg.starIcon} title='Un-Star' onClick={unStarTicket} ></Button> : <Button className='off' svgIcon={svg.starOutlineIcon} title='Star' onClick={starTicket} ></Button>
                            }
                        </li>}
                        {isStaff && <li className="nav-item ms-2 me-2  d-none d-md-inline">
                            <Link to={`/deeplink?url=/calls/callinfo.aspx?call_id=${ticket.ID}`} target='_top' title='Edit'><Button svgIcon={svg.pencilIcon} className='off'></Button></Link>
                        </li>}

                        {isStaff && <li className="nav-item d-md-none mr-2 d-inline">
                            <a data-bs-toggle="collapse" href='#toolMenu'><Button svgIcon={svg.moreHorizontalIcon} className='off' ></Button></a>
                        </li>}
                    </ul>
                </div >
            </div>
            <div className="container-fluid">
                <div className="navbar-collapse collapse hide" id="toolMenu" >
                    <ul className="navbar-nav">
                        {tools.filter(t => t.visible).map((tool, i) => {
                            return <li key={i} className="nav-item">

                                <Link className="nav-link" to={tool.route} title={tool.header}><Button size='medium' icon={tool.icon} imageUrl={tool.img} className='mr-2' ></Button>  {tool.header}</Link>

                            </li>
                        })}

                    </ul>
                </div>
            </div>
        </div >
    </>
    );
}

export default Toolbar;